import { fillUserStore } from '@source/store/user/utilities/services';
import {
    UserAreaProject,
    UserData,
    UserProjectPhase,
    UserPropertyType,
} from '@source/store/user/utilities/store.types';

import { getConstructionNumberIds } from './construction-numbers-id';

const userAreas: UserAreaProject[] = [
    {
        Id: 'a0iw0000009AOvlAAG',
        Name: 'KVL',
        RedirectUrl: 'https://nieuwbouw-kvl.nl',
        LogoUrl: 'https://nieuwbouw-kvl.nl/media/leoo5cyw/logo-kvl.png',
    },
    {
        Id: 'a0iw000000900CZAAY',
        Name: 'Ode',
        RedirectUrl: 'https://nieuwbouw-ode.nl',
        LogoUrl: 'https://nieuwbouw-ode.nl/media/pa3joszb/bpd-ode-logo-design-v2_black.png',
    },
    {
        Id: 'a0i2X00000Cf6aQQAR',
        Name: 'De Nieuwe Defensie',
        RedirectUrl: 'https://nieuwbouw-denieuwedefensie.nl',
        LogoUrl:
            'https://nieuwbouw-denieuwedefensie.nl/media/zwrg0hmm/de-nieuwe-defensie_logo_zwart_cmyk.png',
    },
    {
        Id: 'a0iw0000009NHiTAAW',
        Name: 'Oegstgeestaanderijn',
        RedirectUrl: 'https://nieuwbouw-oegstgeestaanderijn.nl',
        LogoUrl:
            'https://nieuwbouw-oegstgeestaanderijn.nl/media/iz3n5y1b/oegstgeest-aan-de-rijn-90x90-px-zwarte-letter-nieuw.png',
    },
];

const userProjects: UserProjectPhase[] = [
    { Id: 'a062X00001JO34pQAD', Name: 'Kevin Accenture' },
    { Id: 'a062X00001JO34qQAD', Name: 'Lennart Accenture' },
    { Id: 'a062X00001JO3ELQA1', Name: 'Archi Accenture' },
    { Id: 'a062X00001JO312QAD', Name: 'Hans IM' },
    { Id: 'a062X00001JO30sQAD', Name: 'Fleur IM' },
    { Id: 'a063O000003UpopQAC', Name: 'NL For Sale - After allocation [free/option/sold]' },
    { Id: 'a063O000003UpokQAC', Name: 'NL For Sale - Between end of sale and allocation' },
    { Id: 'a063O000003UpofQAC', Name: 'NL For sale - date start for sale until end of sale' },
    { Id: 'a063O000004IrihQAC', Name: 'Rental - in preparation' },
    { Id: 'a063O000000IN3XQAW', Name: 'Accenture Heerlen' },
    { Id: 'a063O000000JdXmQAK', Name: 'Cloud City [ProjectName]' },
    { Id: 'a063O000003U3HVQA0', Name: 'Cloud city phase 15/10' },
    { Id: 'a063O000003U3HVQA0', Name: 'Cloud city phase 15/10' },
    { Id: 'a063O000000JdXmQAK', Name: 'Cloud City [ProjectName]' },
    { Id: 'a062X00001JO30sQAD', Name: 'Fleur IM' },
    { Id: 'a062X0000183vVIQAY', Name: 'Gerard Huur' },
    { Id: 'a062X00001JO39zQAD', Name: 'Annehilde IM' },
];

const userProperties: UserPropertyType[] = [
    { Id: 'a072X00001Gjdr7QAB', ProjectId: 'a062X00001JO34pQAD' },
    { Id: 'a072X00001GjdrCQAR', ProjectId: 'a062X00001JO34qQAD' },
    { Id: 'a072X00001GjdrIQAR', ProjectId: 'a062X00001JO3ELQA1' },
    { Id: 'a072X00001GjdqxQAB', ProjectId: 'a062X00001JO312QAD' },
    { Id: 'a073O000000IAeyQAG', ProjectId: 'a062X00001JO312QAD' },
    { Id: 'a072X00001GjdqiQAB', ProjectId: 'a062X00001JO30sQAD' },
    { Id: 'a073O000002er19QAA', ProjectId: 'a063O000004IrihQAC' },
    { Id: 'a073O000000IAheQAG', ProjectId: 'a063O000000IN3XQAW' },
    { Id: 'a073O000000Sb3rQAC', ProjectId: 'a063O000000JdXmQAK' },
    { Id: 'a073O0000022JB1QAM', ProjectId: 'a063O000003U3HVQA0' },
    { Id: 'a073O0000022JB1QAM', ProjectId: 'a063O000003U3HVQA0' },
    { Id: 'a073O000000Sb3mQAC', ProjectId: 'a063O000000JdXmQAK' },
    { Id: 'a073O000000Sb48QAC', ProjectId: 'a063O000000JdXmQAK' },
    { Id: 'a073O000001FJWBQA4', ProjectId: 'a063O000000JdXmQAK' },
    { Id: 'a073O000000Sb4PQAS', ProjectId: 'a063O000000JdXmQAK' },
    { Id: 'a073O000000Sb3rQAC', ProjectId: 'a063O000000JdXmQAK' },
    { Id: 'a073O000000Sb8MQAS', ProjectId: 'a063O000000JdXmQAK' },
];

export const login = (options?: {
    subscription?: boolean;
    wishlist?: boolean;
    extraData?: Partial<UserData>;
}) => {
    const userData: UserData = {
        Id: 'test-id',
        Email: 'test@deptagency.com',
        DisplayName: 'T Test',
        Initials: 'T T',
        FirstName: 'Test',
        LastName: 'T',
        Salutation: 'Mr',
        Wishlist: options?.wishlist ? getConstructionNumberIds() : [],
        Areas: options?.subscription ? userAreas : [],
        Projects: options?.subscription ? userProjects : [],
        PropertyTypes: options?.subscription ? userProperties : [],
        SubscribedToAreaNewsletter: true,
        HasAddress: false,
        ...options?.extraData,
    };
    fillUserStore(userData);
};

export const loginWithAddress = (options?: {
    subscription?: boolean;
    wishlist?: boolean;
    extraData?: Partial<UserData>;
}) => {
    const { extraData, ...otherOptions } = options ?? {};

    login({
        extraData: {
            PostalCode: '1000aa',
            Street: 'Street',
            HouseNumber: '1',
            HouseNumberAddition: 'B',
            City: 'City',
            PhoneNumber: '0123456789',
            Country: '',
            ...extraData,
        },
        ...otherOptions,
    });
};
